import { FlexColumn } from "@/components/Flex";
import Editor from "@/components/NotePage/Document/Editor/Editor";
import { useNotePageContextSelector } from "@/components/NotePage/hooks/NotePageContext";
import { AuthEvent } from "@/features/Auth/AuthPopup/utils/constants";
import { useBreakPoints, useContainerBreakPoints } from "@/hooks/styles/useBreakpoints";
import { useCurrentUser } from "@knowt/syncing/hooks/user/useCurrentUser";
import dynamic from "next/dynamic";
import { DEFAULT_SIDEBAR_WIDTH, useSidebarContextSelector } from "../hooks/SidebarContext";
import KaiChatFloatingIcon from "@/features/AI/KaiChat/components/KaiChatFloatingIcon";
import Mountable from "@/components/styled/div/Mountable";
import br from "@/styles/breakpoints.module.css";
import { useState } from "react";

const BlurredDocumentBgWithSignupCard = dynamic(() => import("./BlurredDocumentBgWithSignupCard"));
const ScrollProgress = dynamic(() => import("./ScrollProgress"));

const Document = () => {
    const { smDown } = useBreakPoints();

    const { user, loginInProgress } = useCurrentUser();

    const isNoteOwner = useNotePageContextSelector(state => state.isNoteOwner);
    const isNoteSidebarCollapse = useSidebarContextSelector(state => state.isNoteSidebarCollapse);
    const toggleNoteChatSplit = useSidebarContextSelector(s => s.toggleNoteChatSplit);
    const isNoteChatSplitOpen = useSidebarContextSelector(s => s.isNoteChatSplitOpen);

    const [ref, setRef] = useState<HTMLDivElement | null>(null);
    const { mdDown } = useContainerBreakPoints({ container: ref });

    return (
        <FlexColumn ref={setRef} style={{ width: "100%", position: "relative", height: "100%" }}>
            <Editor
                toolbarStyle={{
                    maxWidth: (() => {
                        if (mdDown) {
                            return "90%";
                        } else {
                            return "calc(100vw - var(--editor-side-padding) * 2)";
                        }
                    })(),
                    width: (() => {
                        if (mdDown) {
                            return "clamp(30rem, calc(100vw - 4rem), 80rem)";
                        }
                        return "fit-content";
                    })(),
                }}
            />

            {!user && !loginInProgress && <BlurredDocumentBgWithSignupCard event={AuthEvent.GENERAL_SIGNUP} />}

            {!isNoteOwner && (
                <ScrollProgress
                    style={{
                        position: "fixed",
                        left: smDown ? "3rem" : isNoteSidebarCollapse ? "5rem" : `${7 + DEFAULT_SIDEBAR_WIDTH / 10}rem`,
                        bottom: "5rem",
                    }}
                />
            )}

            <Mountable mount={isNoteOwner}>
                <KaiChatFloatingIcon
                    className={br.smDownDisplayNone}
                    onClick={() => toggleNoteChatSplit()}
                    isOpen={isNoteChatSplitOpen}
                    containerStyle={{ marginLeft: "auto", marginTop: "auto" }}
                />
            </Mountable>
        </FlexColumn>
    );
};

export default Document;
